export default "__VITE_ASSET__DSEUjzM9__"